/**
 * Platform Audit Logs Hook
 */

import { useQuery } from '@tanstack/react-query';
import {
  auditService,
  type FindPlatformAuditLogsQuery,
} from '../services/auditService';

const QUERY_KEYS = {
  platformAuditLogs: (query: FindPlatformAuditLogsQuery) =>
    ['platform', 'audit-logs', query] as const,
};

export interface UsePlatformAuditLogsOptions {
  enabled?: boolean;
}

export function usePlatformAuditLogs(
  query: FindPlatformAuditLogsQuery,
  options: UsePlatformAuditLogsOptions = {}
) {
  return useQuery({
    queryKey: QUERY_KEYS.platformAuditLogs(query),
    queryFn: () => auditService.findPlatformAuditLogs(query),
    enabled: options.enabled ?? true,
  });
}
